import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import SEO from "../../../shared/seo";

// Components //
import Layout from "../../../components/organisms/layout";
import JobDetails from "../../../components/organisms/job-details/JobDetails";
import Loading from "../../../components/atoms/loading/loading";
import VacancyNoFound from "../../../components/molecules/vacancy-nofound";

// Services //
import { getJobsIndividual } from "../../../services/vacante.services";

// SVG //
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

// Styles //
import "./vacante.scss";

interface VacanteInterface {
    params: {
        id: number;
    };
    location: {
        href: string;
        pathname: string;
    };
}

const Vacante = (props: VacanteInterface) => {
    const { iconServicioEmpleo } = useStaticQuery(
        graphql`
            query {
                iconServicioEmpleo: allContentfulAsset(
                    filter: { title: { eq: "logo-magenta-empleo" } }
                ) {
                    nodes {
                        file {
                            url
                        }
                    }
                }
                subcategoriaContent: allContentfulSubcategorias(
                    filter: { titulo: { eq: "Personas > Vacantes activas" } }
                ) {
                    edges {
                        node {
                            slug
                            nombreSubcategoria
                            tipoContenido
                            palabrasClaves
                            referenciaInterna {
                                referenciaContenido {
                                    tituloGeneral
                                    titulo
                                    descripcion {
                                        raw
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    );
    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(false);

    const { isBrowser, window } = useBrowserMode();
    let queryString;
    if (isBrowser) {
        queryString = window.location.search;
    } else {
        queryString = "";
    }
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id");

    const [position, setPosition] = useState<any>(null);

    const getData = async () => {
        setLoading(true);
        await getJobsIndividual(id)
            .then((response) => {
                if (
                    response.data.status === 200 ||
                    response.data.status === 201
                ) {
                    const { data } = response.data;
                    setPosition(data);
                } else {
                    setError(true);
                }
            })
            .catch((err) => {
                console.log("Error get jobs: " + err);
                setError(true);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        getData();
    }, [id]);

    return (
        <Layout location={props.location}>
            <SEO
                title={
                    position &&
                    `${
                        position.title ? position.title : "Vacante disponible"
                    } | Servicio de empleo Comfama`
                }
                description={position && position.description}
                image={
                    iconServicioEmpleo && iconServicioEmpleo.nodes[0].file.url
                }
                lang={"es"}
                slug={props && props.location.pathname}
            />
            {loading && <Loading />}
            {error && !loading && (
               <VacancyNoFound />
            )}
            {position && !loading && !error && (
                <JobDetails jobDetails={position} />
            )}
        </Layout>
    );
};

export default Vacante;
